import React from 'react';

import './TAASPage.css';
import { useNavigate } from 'react-router-dom';

const TaaSPage = () => {
  
  const navigate = useNavigate();
  const handleNavigate = (path) => {
  navigate(path);
  window.scrollTo(0, 0);
};

  return (
    <div className="taas-page">
      <div className="hero-section">
        <div className="container">
          <h1 className="main-header">Data Analytics and Solutions (DAAS)</h1>
          <h2 className="sub-header">From Strategy to Execution: On-Demand Talent that Delivers Results</h2>
          <div className="hero-gradient"></div>
        </div>
      </div>

      <div className="container">
        <section className="intro-section">
          <p className="taas-intro-text">
            Our Data Analytics and Solutions (DAAS) offers a scalable and flexible approach to workforce delivery, 
            supporting a broad range of business initiatives — from high-level strategic projects to operational 
            tasks focused on efficiency and execution.
          </p>
          
          <h2 className="section-header">Why DAAS?</h2>
          
          <div className="benefits-grid">
            <div className="benefit-item agile">
              <div className="icon-container">
                <svg viewBox="0 0 24 24" className="benefit-icon">
                  <path d="M16,4L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14L16,4M17,13H13V9H11V13H7L12,18L17,13Z" />
                </svg>
              </div>
              <h3>⚡ Agile and Fast</h3>
              <p>Need to move fast? Quickly assemble high-performing teams without the delays of traditional recruitment. Stay agile and adapt to market changes with ease.</p>
            </div>
            
            <div className="benefit-item scalable">
              <div className="icon-container">
                <svg viewBox="0 0 24 24" className="benefit-icon">
                  <path d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M9,17H7V10H9V17M13,17H11V7H13V17M17,17H15V13H17V17Z" />
                </svg>
              </div>
              <h3>📈 Scalable</h3>
              <p>Scaling up or down? Adjust your team size as project needs evolve. DAAS gives you the flexibility to scale without long-term commitments.</p>
            </div>
            
            <div className="benefit-item cost">
              <div className="icon-container">
                <svg viewBox="0 0 24 24" className="benefit-icon">
                  <path d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z" />
                </svg>
              </div>
              <h3>💰 Cost-effective</h3>
              <p>Want better budget control? Only pay for the talent you need, when you need it. Ideal for short-term or specialised projects.</p>
            </div>
            
            <div className="benefit-item diverse">
              <div className="icon-container">
                <svg viewBox="0 0 24 24" className="benefit-icon">
                  <path d="M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z" />
                </svg>
              </div>
              <h3>🧠 Access to Diverse Skills</h3>
              <p>Struggling to find local talent? Overcome geographic barriers and connect with the right talents, wherever they are.</p>
            </div>
          </div>
        </section>
        
        <section className="taas-solutions-section">
          <h2 className="taas-section-header">Custom Solutions Tailored to Your Business Goals</h2>
          <div className="taas-solutions-content">
            <p>
              We collaborate closely with clients to understand their unique needs, ensuring that each engagement is fully aligned 
              with their business objectives. Our team of subject-matter experts combines deep industry knowledge with the ability 
              to customise business intelligence, automation, and workflow solutions to enhance operational performance.
            </p>
            <p>
              By leveraging the latest technologies and industry best practices, we help organisations make smarter, data-driven 
              decisions, streamline processes, and boost efficiency — empowering them to stay competitive and achieve meaningful 
              results across all areas of the business.
            </p>
          </div>
          <div className= "taas-learn-more-btn-container">
          <button className="taas-learn-more-btn" onClick={() => handleNavigate('/contactus')}>Contact Us </button> 
        </div>    
        </section>
        
        {/* <section className="taas-portfolio-section">
          <h2 className="taas-section-header">From Concept to Completion: Our Portfolio of Successful Projects</h2>
          
          
        </section> */}                
      </div>
    </div>
  );
};

export default TaaSPage;